import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useUserInfoStore = defineStore('userInfo', () => {
  const token = ref(localStorage.getItem('token') || '')

  const userName = ref('')

  function setToken(value: string) {
    token.value = value;
    if(value){
      localStorage.setItem('token', value)
    }else{
      localStorage.removeItem('token')
    }
  }

  function setInfo(value: string) {
    userName.value = value;
  }

  return { token, setToken, userName, setInfo }
})
